import { withT } from "../tools";

export const StatusConfig = {
  coming: {
    label: 'group.ComingSoon',
    bgColor: 'linear-gradient(90deg, #ff5253 0%, #ff3a67 100%)',
  },
  inprogress: {
    label: 'group.InProgress',
    bgColor: 'linear-gradient(90deg, #fc833a 0%, #ffbe3f 100%)',
  },
  ended: {
    label: 'listing.Ended',
    color: 'rgba(255,255,255,0.4)',
    bgColor: 'rgba(255,255,255,0.08)',
  },
  soldout: {
    label: 'group.SoldOut',
    color: 'rgba(255,255,255,0.4)',
    bgColor: 'rgba(255,255,255,0.08)',
    // bgColor: 'linear-gradient(90deg, #4d555e 0%, #3a3f47 100%)',
  },
};

const StatusLabel = ({
  t,
  status,
  className,
}) => {
  const statusConfig = StatusConfig[status] || {};

  return (
    <div
      className={"text-[#fff] text-[14px] sm:text-[12px] rounded-[4px] p-[2px_10px] sm:p-[2px-3px] inline-flex items-center sm:h-[22px] " + className}
      style={{
        background: statusConfig.bgColor,
        color: statusConfig.color,
      }}
    >
      <span>{t(statusConfig.label)}</span>
    </div>
  );
};

export default withT(StatusLabel);
